export default "<% if (user) { %>\n<h2><%= user.name %></h2>\n<% } %>\n"